// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { format, formatDistance as formatDistanceDateFns } from "date-fns";
import { getLoadedLocale } from "./locale";

type FormatDistanceOptions = {
  includeSeconds?: boolean;
  addSuffix?: boolean;
  locale: string;
};

export const formatDistance = (from: Date, to: Date, options: FormatDistanceOptions) => {
  return formatDistanceDateFns(from, to, {
    ...options,
    locale: getLoadedLocale(options.locale, true, true),
  });
};

export const formatDate = (date: string, options: FormatDistanceOptions) => {
  const d = new Date(date);
  return format(d, "MMM d, yyyy", { locale: getLoadedLocale(options.locale, true, true) });
};

export const getLocale = (locale: string) => {
  return getLoadedLocale(locale, true, true);
};
